import { render, staticRenderFns } from "./veStuCheckItemShow.vue?vue&type=template&id=6baff0d8&scoped=true"
import script from "./veStuCheckItemShow.vue?vue&type=script&lang=js"
export * from "./veStuCheckItemShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baff0d8",
  null
  
)

export default component.exports